import { render, staticRenderFns } from "./MarketOverallIncome.component.vue?vue&type=template&id=8b9030ce&scoped=true"
import script from "./MarketOverallIncome.component.vue?vue&type=script&lang=js"
export * from "./MarketOverallIncome.component.vue?vue&type=script&lang=js"
import style0 from "./MarketOverallIncome.component.vue?vue&type=style&index=0&id=8b9030ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9030ce",
  null
  
)

export default component.exports